import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import { FormalOfferProductType } from './MyOffers.types';
import { getCountry } from '@iwIntlProvider/CountryProvider';

export const getFormalOfferType = (
    data: GetFormalOffersResponse,
    isInUniApprovedViewSplitTest: boolean
): FormalOfferProductType => {
    // interest_only_repayments isn't returned for standard flexi loans
    const hasInterestOnlyOffer = data.data!.formal_offers.find(
        (formal_offer) =>
            formal_offer.interest_only_repayments &&
            formal_offer.interest_only_repayments > 0
    );
    if (data.data!.formal_offers.length === 1) {
        if (getCountry() === 'DE' && hasInterestOnlyOffer) {
            return 'x_sell';
        }
        return data.data!.formal_offers[0].product_type!;
    } else {
        if (getCountry() === 'DE') {
            return 'x_sell';
        } else if (hasInterestOnlyOffer || isInUniApprovedViewSplitTest) {
            //force users assigned to the uniApprovalView test or interest-only to see the 'credit_facility' approval view
            return data.data!.formal_offers[0].product_type!;
        } else return 'multi_choice';
    }
};
